import React, { useState, useEffect } from 'react';
import { Link, Tooltip } from '@mui/material';

import { Axios } from '@helpers';

interface IProps {
  url: string;
  id: string;
  modelId: string;
}

const MainUrlLink = (props: IProps) => {
  const { url, id, modelId } = props;

  const [isHovering, setIsHovering] = useState<boolean>(false);
  const [imageUrl, setImageUrl] = useState<string>('');
  const [isLoadingImage, setIsLoadingImage] = useState<boolean>(true);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        setIsLoadingImage(true);
        const result = await Axios.get(
          `/admin/models/${modelId}/social-media-links/${id}/evidence`,
        );

        if (result.data && result.data.length > 0) {
          setImageUrl(result.data[0].url);
        }
      } finally {
        setIsLoadingImage(false);
      }
    };

    if (isHovering && !imageUrl) {
      fetchImage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHovering]);

  const onMouseEnter = () => setIsHovering(true);

  const onMouseLeave = () => setIsHovering(false);

  return (
    <Tooltip
      open={isHovering && !isLoadingImage}
      placement="bottom-end"
      title={
        <iframe
          id={`${id}-${modelId}`}
          style={{
            backgroundColor: '#fff',
            padding: '10px',
            borderRadius: '8px',
            boxShadow: '3px 2px 11.1px 0px #00000040',
            width: '500px',
            height: '323px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            pointerEvents: 'auto',
          }}
          srcDoc={`<style>html{height:100vh} body{margin:0;display:flex;justify-content:center;align-items:center;height:100%;width:100%} img{height:100%}</style><img src='${imageUrl}' alt='No evidence available' />`}
        />
      }
    >
      <Link
        href={url}
        target="_blank"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'block',
          maxWidth: '100%',
        }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {url}
      </Link>
    </Tooltip>
  );
};

export default MainUrlLink;
